<template>
  <div class="md:p-12 lg:p-12 p-6">
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(handleSend)">
        <div
          class="grid md:grid-cols-3 gird-cols-1 lg:grid-cols-3 gap-x-10 gap-y-6"
        >
          <div class="">
            <p class="input-title-black">Name</p>
            <b-form-input
              v-model="name"
              placeholder="Enter your name"
              class="border-0"
              name="Name"
              :rules="{ required: true }"
            ></b-form-input>
          </div>
          <div class="">
            <p class="input-title-black">Email Address</p>
            <b-form-input
              v-model="email"
              placeholder="Enter your EmailID"
              class="border-0"
              name="Email"
              :rules="{ required: true, email: true }"
            ></b-form-input>
          </div>
          <div class="">
            <p class="input-title-black">Mobile No.</p>
            <b-form-input
              v-model="mobile"
              placeholder="Enter your Mobile No."
              class="border-0"
              name="Mobile No."
              :rules="{ required: true }"
            ></b-form-input>
          </div>

          <div class="">
            <p class="input-title-black">LinkedIn</p>
            <b-form-input
              v-model="linkedin"
              placeholder="Enter your LinkedIn ID"
              class="border-0"
              name="LinkedIn"
              :rules="{ required: true }"
            ></b-form-input>
          </div>
          <div class="">
            <p class="input-title-black">CV</p>
            <b-form-file
              v-model="cv"
              placeholder="Attach"
              class="border-0"
            ></b-form-file>
          </div>
        </div>

        <div class="md:pt-10 lg:pt-10 pt-6 w-full">
          <b-button
            type="submit"
            variant="secondary"
            class="md:px-12 lg:px-12 px-6 md:py-2 lg:py-2 py-1 border-2 md:text-base lg:text-base text-sm font-bold"
            >Send Message</b-button
          >
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import emailMixin from "@/mixins/email";
import { mapState } from "vuex";

export default {
  mixins: [emailMixin],
  props: {
    subject: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      name: "",
      email: "",
      mobile: "",
      linkedin: "",
      cv: null,
    };
  },
  computed: {
    ...mapState("auth", { user: "user" }),
  },
  methods: {
    async handleSend() {
      const bcc = [
        "yash.singh@aiab.in",
        "bhavana.issar@caregiversaathi.co.in",
        "dona.mohapatra@caregiversaathi.co.in",
      ];
      // const to = ["sudeshna.banerjee@caregiversaathi.co.in"];
      const to = ["careers@caregiversaathi.co.in"];
      const subject = this.subject;
      const body = `
      Name: ${this.name}<br />
      Email Address: ${this.email}<br />
      Mobile No.: ${this.mobile}<br />
      LinkeIn: ${this.linkedin}<br />
      `;
      await this.sendEmail(to, subject, body, [], bcc, true, this.cv);
      this.$refs.formValidator.reset();
      this.successAlert();
    },
  },
  mounted() {
    if (!!Object.keys(this.user).length) {
      this.email = this.user.email;
      this.name = `${this.user.firstname} ${this.user.lastname}`;
      this.mobile = this.user.mobile;
    }
  },
};
</script>
